<!--suppress AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg _ngcontent-bai-c1="" class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path _ngcontent-bai-c1="" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline _ngcontent-bai-c1="" points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Clients</li>
  </ol>
</nav>
<div [hidden]="loading" class="row layout-spacing layout-top-spacing" id="cancel-row">
  <div class="col-lg-12">
    <div class="widget-content searchable-container list">
      <div class="row">
        <div class="col-xl-4 col-lg-5 col-md-5 col-sm-7 filtered-list-search layout-spacing align-self-center">
          <form class="form-inline my-2 my-lg-0">
            <div class="">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input type="text" class="form-control product-search" id="input-search" placeholder="{{'Search Contacts...' | translate}}">
            </div>
          </form>
        </div>
      </div>

      <div class="searchable-items list">
        <div class="items items-header-section">
          <div class="item-content">
            <div>
              <h4 class="text-primary" style="margin-right: 0">Name</h4>
            </div>
            <div class="user-phone">
              <h4 class="text-primary" style="margin-left: 3px;">Phone</h4>
            </div>
          </div>
        </div>

        <div *ngFor="let c of clients" class="items">
          <div *ngIf="c.name || c.mobile" class="item-content">
            <div class="user-profile my-1">
<!--              <img src="assets/img/90x90.jpg" alt="avatar">-->
              <div class="user-meta-info">
                <p class="user-name" [attr.data-name]="c.name">{{c.name}}</p>
              </div>
            </div>
            <div class="user-phone my-1">
              <p class="info-title">Phone: </p>
              <p class="usr-ph-no" [attr.data-phone]="c.mobile">{{c.mobile}}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
